<template>
  <form @keyup.enter="save">
    <div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label field-required">Name</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'required|max:100'"
              :class="{'is-danger': errors.has('name') }"
              name="name"
              v-model="body.name"
              class="input"
              type="text"
              placeholder="Enter name"
            />
            <span
              v-show="errors.has('name')"
              class="help is-danger"
            >{{ errors.first('name') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label field-required">Description</label>
        </div>
        <div class="control is-grouped column is-9">
          <p class="control is-expanded">
            <input
              v-validate="'required|max:255'"
              :class="{'is-danger': errors.has('description') }"
              name="description"
              v-model="body.description"
              class="input"
              type="text"
              placeholder="Enter description"
            />
            <span
              v-show="errors.has('description')"
              class="help is-danger"
            >{{ errors.first('description') }}</span>
          </p>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Parent</label>
        </div>
        <div class="control is-grouped column is-9">
          <div
            class="select"
            style="width:100%"
          >
            <select
              v-model="body.parent_id"
              style="width:100%"
            >
              <option :value="null">No</option>
              <option
                v-if="c.id != body.id"
                v-for="(c, key) in categories"
                :key="key"
                :value="c.id"
              >{{c.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label">Banner</label>
        </div>
        <div class="control is-grouped column is-9">
          <cate-dropzone
            :data="gallery"
            @input="onGallery"
            @featured="setFeaturedImage"
            :featured="body.banner"
          ></cate-dropzone>
          <!-- :checkRatio.sync="checkRatio" -->
          <!-- <span
            v-if="checkRatio"
            class="help is-danger"
          >The image should be 21:9 ratio.</span> -->
          <span class="helper-text">The banner should be 21:9 ratio.</span>
        </div>
      </div>
      <div class="control is-horizonetal columns">
        <div class="control-label column is-3 label-create"></div>
        <div class="control is-grouped column is-9">
          <p
            class="control is-expanded is-flex"
            style="align-items: center"
          >
            <!-- <span style="margin-right: 10px">Hyperlink:</span> -->
            <input
              :class="{'is-danger': errors.has('hyperlink') }"
              name="hyperlink"
              v-model="body.hyperlink"
              class="input"
              type="text"
              placeholder="Enter hyperlink"
            />
            <span
              v-show="errors.has('hyperlink')"
              class="help is-danger"
            >{{ errors.first('hyperlink') }}</span>
          </p>
        </div>
      </div>

      <div class="control is-horizontal columns">
        <div class="control-label column is-3 label-create">
          <label class="label"></label>
        </div>
        <div class="control column is-9">
          <save-button
            :loading="isSaving"
            @click="save"
          />
          <a
            @click="cancel"
            class="button is-link"
          >Cancel</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { categoryPost } from "api";
  export default {
    components: {
      'cate-dropzone': () => import('./components/cate-dropzone'),
    },
    props: {
      data: {
        type: Object,
        default () {
          return {};
        }
      },
      isSaving: Boolean
    },
    data () {
      return {
        body: {
          name: this.data.name ? this.data.name : "",
          description: this.data.description ? this.data.description : "",
          parent_id: this.data.parent_id ? this.data.parent_id : null,
          banner: this.data.banner ? this.data.banner : "",
          hyperlink: this.data.hyperlink ? this.data.hyperlink : ""
        },
        gallery: [],
        categories: [],
        checkRatio: false,
        isLoading: false
      };
    },
    mounted () {
      // if (this.data.id) {
      //   this.getTreeCat()
      // } else {
      //   this.getCategoriesPost();
      // }
      // let gallery = [];
      // if (this.body.banner) {
      //   gallery.push(this.body.banner);
      // }
      // this.gallery = gallery;
      // console.log('this.gallery :>> ', this.gallery);
    },
    methods: {
      onGallery (data) {
        this.gallery = data;
      },
      setFeaturedImage (img) {
        this.body.banner = img;
      },
      getTreeCat () {
        let params = {
          hidden_id: this.data.id
        };
        categoryPost
          .getTreeCat(params)
          .then(res => {
            if (res.data.success === true) {
              this.categories = res.data.data;
            }
          })
          .catch(err => { });
      },
      getCategoriesPost () {
        let me = this;
        let filter = {
          sort: "parent"
        };
        categoryPost
          .getCat(filter)
          .then(res => {
            if (res.data.success === true) {
              me.categories = res.data.data;
            }
          })
          .catch(err => { });
      },
      cancel () {
        this.$emit("cancel");
      },
      save () {
        this.$validator.validateAll().then(result => {
          if (result && !this.checkRatio) {
            if (this.gallery.length > 0) {
              this.body.banner = this.gallery[0];
            } else {
              this.body.banner = "";
            }
            this.$emit("save", this.body);
          }
        });
      },
      find () {
        let loader = this.$loading.show();
        categoryPost.find(this.$route.params.id).then(res => {
          if (res.data.success === true) {
            this.body = res.data.data;
            let gallery = [];
            if (this.body.banner) {
              gallery.push(this.body.banner);
            }
            this.gallery = []
            this.gallery = gallery;
            loader.hide();
          }
        }).catch(err => {
          if (err.response && err.response.status == '404') {
            this.$router.replace({ path: '/404' })
          }
          loader.hide();
        });
      },
    },
    created () {
      if (this.data.id) {
        this.getTreeCat();
      } else {
        this.getCategoriesPost();
      }
      if (this.$route.params.id) {
        this.find()
      }
    },

  };
</script>

<style scoped>
</style>
